'use client';

import React, { FC } from 'react';

import AddIcon from '@/components/ui/Icons/AddIcon';

import { Link } from '@/navigation';

import {
  CLICKED_ITEM_TYPES,
  CTA_NAMES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
} from '@/utils/rudderstack';

import {
  buildRelativeInternalUrl,
  buildQueryString,
} from '@/utils/shopSubdomain';

import styles from './AddChild.module.scss';

export type AddChildProps = {
  title: string;
};

const AddChild: FC<AddChildProps> = ({ title }) => {
  const handleClick = (cta: CTA_NAMES) => {
    trackItemClickedEvent({
      url: window.location.href,
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.PLAY_KITS_PAGE,
      cta: cta,
    });
  };

  function _addChildLink() {
    const queryString = buildQueryString([
      {
        key: 'page_source',
        value: 'subscriptions',
      },
    ]);

    return buildRelativeInternalUrl(
      ['account', 'v2', 'settings', 'add-a-child'],
      queryString,
    );
  }

  return (
    <div data-testid="add-child-item" className="flex flex-col content-center">
      <Link
        href={_addChildLink()}
        onClick={() => handleClick(CTA_NAMES.ADD_CHILD)}
      >
        <div
          className={`relative w-[88px] h-[88px] lg:w-28 lg:h-28 mx-auto flex items-center overflow-hidden z-10 bg-indigo-pastel rounded-full ${styles.dashStyle}`}
        >
          <div className="mx-auto">
            <AddIcon />
          </div>
        </div>

        <p className="mt-2 font-bold text-center text-base lg:text-xl text-blue-deep hover:text-blue-deep-hover">
          {title}
        </p>
      </Link>
    </div>
  );
};

export default AddChild;
